<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import notification from "@/utils/plugins/NotificationService";
import FormProject from "./FormProject.vue";
import ProjectsService from '@/api/services/projects.service';

//import moment from 'moment';

import { onMounted, ref } from "vue";
import { useUiStore } from "@/app/stores/uiStore";
import { useRoute } from "vue-router";

const uiStore = useUiStore();

const route = useRoute();

const showFormProject = ref(false);

const project = ref({
  name: '',
  date_ini: '',
  client: {
    id: '',
    name: ''
  },
  nro_horas: '',
  projectType: {
    id: '',
    name: ''
  },
  projectManager: '',
  clockifyProject: '',
  consumedTime: '',
  contractedTime: '',
  tag: '',
  initialDate: '',
  lastSynchronization: '',
  observations: '',
  minConsumptionHours: 0,
  reviewPeriodMonths: null
});

function getProject(id) {
  uiStore.startLoading();
  ProjectsService.getProject(id).then(result => {
    project.value = result.data;
    showFormProject.value = true;
    uiStore.stopLoading();

    //moment.locale('es');
    //$this.project.lastSynchronization = moment($this.project.lastSynchronization,"yyyy-MM-DDTHH:mm:ssZ").format("yyyy-MM-dd HH:mm:ss");
  }).catch(err => {
    console.error("Types", err);
    notification.addNotification({
      title: 'Proyecto no encontrado',
      message: 'Error al intentar obtener los campos del proyecto seleccionado' + err,
      type: 'error',
      duration: 6000
    });
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    showFormProject.value = false;
  });
}

function updateObservation(obj) {
  console.log("Update Project", obj);
  uiStore.startLoading();
  const params = {
    observations: obj.observations,
    tag: obj.tag,
    minConsumptionHours: obj.minConsumptionHours,
    reviewPeriodMonths: obj.reviewPeriodMonths
  };
  if (isConnectusProject(obj)) {
    params.name = obj.name;
    params.client = getProjectResource(obj.client);
    params.projectType = getProjectResource(obj.projectType);
    params.initialDate = obj.initialDate;
  }
  if (obj.ownerDepartmentHasChanged) {
    params.ownerDepartment = obj.ownerDepartment ? getProjectResource(obj.ownerDepartment) : null;
  } else if (obj.ownerDepartment) {
    params.ownerDepartment = getProjectResource(obj.ownerDepartment);
  }
  if (Object.prototype.hasOwnProperty.call(obj, 'billable')) {
    params.billable = obj.billable;
  }
  if (Object.prototype.hasOwnProperty.call(obj, 'archived')) {
    params.archived = obj.archived;
  }
  if (isConnectusProject(obj)) {
    params.contractedTime = obj.contractedTime;
  }
  ProjectsService.udpdateObservations(params, route.params.id).then(res => {
    if (res?.data) {
      project.value = res.data;
    }
    notification.addNotification({
      title: 'Actualización del proyecto',
      message: 'Se han actualizado los del proyecto seleccionado',
      type: 'success',
      duration: 6000
    });
    uiStore.stopLoading();
  }).catch(err => {
    notification.addNotification({
      title: 'Error al intentar modificar el proyecto seleccionado',
      message: err,
      type: 'error',
      duration: 6000
    });
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  });
}

function isConnectusProject(project) {
  const source = String(project?.source || '').trim().toLowerCase();
  return source === 'connectus';
}

function isConnectusBhProject(project) {
  const source = String(project?.source || '').trim().toLowerCase();
  const projectType = String(project?.projectType?.name || project?.projectType || '').trim().toUpperCase();
  return source === 'connectus' && projectType === 'BH';
}

function getProjectResource(field) {
  return field?.['@id'] || field?.id || field;
}

async function updateObservationDocuments(obj) {
  await changeObservationDocuments(obj);
  notification.addNotification({
    title: 'Actualización del proyecto',
    message: 'Se ha actualizado el proyecto',
    type: 'success',
    duration: 6000
  });
}

async function deleteObservationDocuments(obj) {
  await changeObservationDocuments(obj);
}

function changeObservationDocuments(obj) {
  let documentEstimate = [];
  let documentProposal = [];
  if (obj.projectEstimationDocuments.length > 0) {
    for (let i = 0; i < obj.projectEstimationDocuments.length; i++) {
      const id = obj.projectEstimationDocuments[i];
      documentEstimate.push(id['@id']);
    }
  } else {
    if (obj.projectEstimationDocuments['@id']) {
      documentEstimate.push(obj.projectEstimationDocuments['@id']);
    }
  }
  if (obj.projectProposalDocuments.length > 0) {
    for (let i = 0; i < obj.projectProposalDocuments.length; i++) {
      const id = obj.projectProposalDocuments[i];
      documentProposal.push(id['@id']);
    }
  } else {
    if (obj.projectProposalDocuments['@id']) {
      documentProposal.push(obj.projectProposalDocuments['@id']);
    }
  }
  let params = {};
  if (documentEstimate.length > 0) {
    params.projectEstimationDocuments = documentEstimate;
  }
  if (documentProposal.length > 0) {
    params.projectProposalDocuments = documentProposal;
  }
  ProjectsService.udpdateObservations(params, route.params.id).then(res => {
    project.value = res.data;
    console.log(project.value);
  }).catch(err => {
    console.log(err);
    notification.addNotification({
      title: 'Error al intentar modificar el proyecto seleccionado',
      message: err,
      type: 'error',
      duration: 6000
    });
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  });
}

onMounted(() => {
  getProject(route.params.id);
});
</script>

<template>
  <form-project v-if="showFormProject" :project="project" @change="updateObservation"
    @add-document="updateObservationDocuments" @delete="deleteObservationDocuments" />
</template>
